export { ReactComponent as Image } from './svgs/image.svg';
